import { render } from "./ClosingCredits.vue?vue&type=template&id=1f748262&scoped=true&ts=true"
import script from "./ClosingCredits.vue?vue&type=script&lang=ts"
export * from "./ClosingCredits.vue?vue&type=script&lang=ts"

import "./ClosingCredits.vue?vue&type=style&index=0&id=1f748262&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f748262"]])

export default __exports__